import { useMemo } from 'react';

import { TAiPageChatMessageDto } from '@app-velocity/av-api-v2';

import { cycleDetection } from '../../../utils/cycle-detection';

// Cycle detection is disabled here, simulation service is handling it
const CYCLE_DETECTION_ENABLED = false;

export const useCycleDetection = (visitedPages: TAiPageChatMessageDto[]) => {
  const { occurences, cycle } = cycleDetection(
    visitedPages.map((message) => message.pageId!)
  );

  const detectedCycle = useMemo(() => {
    if (
      CYCLE_DETECTION_ENABLED &&
      ((cycle.length > 1 && occurences >= 3) || occurences >= 5)
    ) {
      return { cycle, occurences };
    }

    return null;
  }, [cycle, occurences]);

  return detectedCycle;
};
